export function getMobileOS() {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const platform = navigator.platform || "";
    const maxTouch = navigator.maxTouchPoints || 0;

    // Detect Android
    if (/android/i.test(ua)) {
        return "Android";
    }

    // Nuevo API cuando está disponible
    if (navigator.userAgentData && navigator.userAgentData.platform === "iOS") {
        return "iOS";
    }

    // Detect iOS clásico (Safari)
    if (/iPad|iPhone|iPod/.test(ua)) {
        return "iOS";
    }

    // Detect iPadOS que se identifica como Mac
    if (platform === "MacIntel" && maxTouch > 1) {
        return "iOS";
    }

    // Detect iOS WebView (sin Safari en userAgent)
    if (/iPhone|iPad|iPod/.test(ua) && !/Safari/.test(ua)) {
        return "iOS";
    }

    return "Other";
}

export const isMobile = {
    AndroidWebView: ()=>{
        return Boolean(typeof Android !== "undefined") || window.platformOS === "android";
    },
    IosWebView: ()=>{
        return Boolean(typeof window.webkit !== "undefined" && window.webkit.messageHandlers);
    },


    Android: function() {
        let os = getMobileOS()
        return os === "android";
    },

    iOS: function() {
        let os = getMobileOS()
        return os === "iOS";
    },


    anyWebView(){
        return isMobile.AndroidWebView() || isMobile.IosWebView() || !!window.ReactNativeWebView;
    },
    reactNative(){
        return  !!window.ReactNativeWebView;
    }
};




export default isMobile;

